import React, { useState, useEffect, useCallback } from 'react';
import { navigate } from 'gatsby';
import styled from 'styled-components';
import { Search } from '@styled-icons/material-outlined';

import Hamburger from 'components/Hamburger/hamburger';
import MobileMenu from 'components/MobileMenu/mobileMenu';
import DesktopMenu from 'components/DesktopMenu/desktopMenu';
import BotomButton from 'components/BotomButton/botomButton';
import HeroButton from 'components/HeroButton/heroButton';
import Logo from 'components/Logo/logo';

const StyledWrapper = styled.header`
  position: sticky;
  top: 0;
  left: 0;
  display: flex;
  background: ${({ theme }) => theme.color.first};
  width: 100%;
  height: 50px;
  z-index: 9999;
  box-shadow: 0px 4px 16px #bbb8b8;
  align-items: center;
  ${({ theme }) => theme.mq.desktop} {
    height: 60px;
  }
`;

const SearchButton = styled(HeroButton)`
  display: none;
  opacity: 1;
  width: 160px;
  height: 46px;
  background: ${({ theme }) => theme.color.second};
  border: 2px solid ${({ theme }) => theme.color.second};
  padding: 0;
  margin: 0 10px 0 0;
  &:hover {
    font-weight: ${({ theme }) => theme.font.weight.bold};
  }
  ${({ theme }) => theme.mq.desktop} {
    display: block;
  }
`;

const StyledSearch = styled(Search)`
  margin-left: 10px;
`;

function Header() {
  const [isMenuOpen, setMenuState] = useState(false);
  const [isVisibleButton, setVisible] = useState(false);

  const goOnTopHandler = () => {
    window.scrollTo(0, 0);
  };

  const handler = useCallback(() => {
    const position = window.scrollY;
    const windowHeight = window.outerHeight;
    setVisible(position > windowHeight || false);
  });

  useEffect(() => {
    window.addEventListener('scroll', handler);

    return () => window.removeEventListener('scroll', handler);
  }, []);

  const toggleMenuState = () => {
    setMenuState(!isMenuOpen);
  };

  return (
    <StyledWrapper>
      <Logo />
      <DesktopMenu />
      <Hamburger onClick={toggleMenuState} isOpen={isMenuOpen} />
      <MobileMenu closeMenu={() => toggleMenuState()} isOpen={isMenuOpen} />
      <BotomButton isVisible={isVisibleButton} goOnTop={goOnTopHandler} />
      <SearchButton id="szukajHeader" onClick={() => navigate('/#search')}>
        szukaj
        <StyledSearch size="25" title="Search" />
      </SearchButton>
    </StyledWrapper>
  );
}

export default Header;
